export const MEDIA_BREAKPOINTS: { [key: string]: string } = {
  X_LARGE: '@media (min-width: 1201px)',
  LARGE: '@media (max-width: 1200px)',
  MEDIUM: '@media (max-width: 1000px)',
  SMALL: '@media (max-width: 700px)',
};
